import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useCurrentStore } from 'hooks'
import { TypeRoute } from 'core/TypeRoute'
import { generatePath } from 'react-router-dom'
import { useMemo } from 'react'
import { KBreadcrumbs } from 'components/core/KBreadcrumbs'
import { StoreName } from './StoreName'

export const SubmitOrderHeader = () => {
  const { t } = useTranslation()
  const { store } = useCurrentStore()
  const tableInfo = store?.table_info
  const breadcrumbs = useMemo(() => {
    if (tableInfo) {
      return [
        { label: t(tableInfo.area_name) },
        { label: t(tableInfo.table_name) },
        {
          label: t('Ordering'),
          to: generatePath(TypeRoute.TableOrdering, {
            storeId: store!.id,
            tableId: tableInfo.table_id,
          }),
        },
        { label: t('Checkout') },
      ]
    }

    return [
      { label: t('Stores') },
      {
        label: store?.name ?? '',
        to: generatePath(TypeRoute.StoreInfo, { storeId: store?.id ?? '' }),
      },
      {
        label: t('Ordering') ?? '',
        to: generatePath(TypeRoute.Ordering, { storeId: store?.id ?? '' }),
      },
      {
        label: t('Checkout'),
      },
    ]
  }, [store, t, tableInfo])
  return (
    <Stack sx={{ paddingY: 2, gap: 1.5 }}>
      <KBreadcrumbs breadcrumbs={breadcrumbs} />
      <StoreName store={store} />
    </Stack>
  )
}
